import { stylesCSS } from "./styles-css";
export function initHTML() {
    document.querySelector(".cp-bulletin-board-settings-container").innerHTML =
        `
        <style>
            ${stylesCSS()}
        </style>
        <div class="cp-bulletin-board-settings"></div>
    `;
}
